export const changePassword = {
    title: 'Change Password',
    CurrentPassword: {
        name: 'Current Password',
        placeholder: 'Current Password',
        required: 'Please enter a current password',
        too_short: '',
        invalid: '',
    },
    NewPassword: {
        name: 'New Password',
        placeholder: 'New Password',
        required: 'Please enter NewPassword',
        too_short: 'Please enter your password with at least 8 characters contains a-z, A-Z, or 0-9. ',
        invalid: '',
        invalidformat: 'Please enter your password with at least 8 characters contains a-z, A-Z, or 0-9. ',
        match: 'The new password matches the current password Please enter a new password again.'
    },
    ConfirmPassword: {
        name: 'Confirm New Password',
        placeholder: 'Confirm New Password',
        required: 'Please enter ConfirmPassword',
        too_short: '',
        invalid: '',
        not_match: 'Passwords don’t match',
    },
    confirm_popup: {
        title: 'Confirm?',
        msg: 'Do you confirm to change a new password?',
        btn_ok: 'Confirm',
        btn_cancel: 'Cancel',
    },
    Success_popup: {
        title: 'Update Password successfully',
        msg: 'Your password has been changed successfully.Please use a new password to log in',
        btn_ok: 'Login now!',
    },
    forget: 'Forget password ?',
    save_btn: 'Change password',
}
